export enum IpMode {
	DHCP = 'DHCP',
	STATIC = 'STATIC'
}
